var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/dom2life/dom2life/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/PopupSections/PopupSections.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
["sections"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("sections", kwargs.hasOwnProperty("sections") ? kwargs["sections"] : []);
var t_2 = "";var t_3;
t_3 = (lineno = 1, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "cycler"), "cycler", context, ["PopupSections-section--1","PopupSections-section--2"]));
frame.set("color_cycler", t_3, true);
if(frame.topLevel) {
context.setVariable("color_cycler", t_3);
}
if(frame.topLevel) {
context.addExport("color_cycler", t_3);
}
t_2 += "<div class=\"PopupSections\">\n        <div class=\"PopupSections-inner\">\n            <header class=\"PopupSections-header\">Эксклюзив</header>\n            <button class=\"PopupSections-btn\"></button>\n\n            <div class=\"PopupSections-list\">\n                ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "sections");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("s", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
t_2 += "\n                    ";
if(runtime.memberLookup((t_7),"title") != "Новости" && runtime.memberLookup((t_7),"title") != "Кастинг" && runtime.memberLookup((t_7),"title") != "Участники") {
t_2 += "\n                        <a class=\"PopupSections-section ";
t_2 += runtime.suppressValue((lineno = 11, colno = 74, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "color_cycler")),"next"), "color_cycler[\"next\"]", context, [])), env.opts.autoescape);
t_2 += "\"\n                           href=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((t_7),"link"), env.opts.autoescape);
t_2 += "\">\n                            <img class=\"PopupSections-img\"\n                                 src=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"img")),"w380"), env.opts.autoescape);
t_2 += "\"\n                                 srcset=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"img")),"w790"), env.opts.autoescape);
t_2 += " 2x\"\n                                 alt=\"";
t_2 += runtime.suppressValue(runtime.memberLookup((t_7),"title"), env.opts.autoescape);
t_2 += "\">\n                            <span class=\"PopupSections-title\">";
t_2 += runtime.suppressValue(runtime.memberLookup((t_7),"title"), env.opts.autoescape);
t_2 += "</span>\n                        </a>\n                    ";
;
}
t_2 += "\n                ";
;
}
}
frame = frame.pop();
t_2 += "\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("PopupSections");
context.setVariable("PopupSections", macro_t_1);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "render")) {
output += "\n    ";
output += runtime.suppressValue((lineno = 27, colno = 18, runtime.callWrap(macro_t_1, "PopupSections", context, [runtime.contextOrFrameLookup(context, frame, "sections")])), env.opts.autoescape);
output += "\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/PopupSections/PopupSections.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PopupSections/PopupSections.jinja
// module id = 268
// module chunks = 0